import { parse } from 'date-fns';

export const MIN_START_UTC_STRING = '2000-01-01T00:00:00.000Z';
export const MAX_END_UTC_STRING = '2099-01-31T23:59:59.999Z';

export const SHORT_DATE_FORMAT = `yyyy-MM-dd`;
export const SHORT_TIME_FORMAT = `HH:mm:ss`;
export const LONG_DATE_FORMAT = `yyyy-MM-dd HH:mm:ss`;
export const PRIME_SHORT_DATE_FORMAT = 'yy-mm-dd';
export const TIMEZONE = `UTC`;

export function convertUTCToLocalDateWithoutTimezone(utc: string): Date {
  const date = new Date(utc);
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() + offset * 60000);
}

export function convertLocalDateToUTCWithoutTimezone(local: Date): string {
  const offset = local.getTimezoneOffset();
  const utcDate = new Date(local.getTime() - offset * 60000);
  return utcDate.toISOString();
}

export function formatMinutesToMSS(minutes: number): string {
  if (typeof minutes !== 'number' || isNaN(minutes)) {
    return '';
  }
  const min = Math.floor(minutes);
  const sec = Math.round((minutes - min) * 60);
  return `${minutes >= 0 ? min : 0}:${sec.toString().padStart(2, '0')}`;
}

export function parseDateIgnoreTimezone(dateString: string): Date {
  const match = dateString.match(
    /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})(\.\d{1,3})?/,
  );
  if (!match) throw new Error(`Invalid date format: ${dateString}`);
  const datePart = match[1];
  const timePart = match[2];
  let msPart = match[3] || '';
  if (!msPart) msPart = '.000';
  msPart = msPart.padEnd(4, '0');
  return parse(
    `${datePart} ${timePart}${msPart}`,
    'yyyy-MM-dd HH:mm:ss.SSS',
    new Date(),
  );
}
